import { DropdownOptionProps } from ".";

export function onChangeMultiselect(value: any, prevValue: any) {
  if (!Array.isArray(prevValue)) prevValue = [];

  const exists = prevValue?.includes(value);
  if (exists) {
    return prevValue.filter((v: any) => v !== value);
  } else {
    return [...prevValue, value];
  }
}

export function getOptionNames(value: any, options: DropdownOptionProps[]) {
  if (Array.isArray(value)) {
    if (value.length > 1) {
      return `${value.length} selecionados`;
    }
    return options
      .filter((option) => value.includes(option.value))
      .map((o) => o.name)
      .join(", ");
  }
  const option = options.find((option) => option.value === value);
  return option ? option.name : undefined;
}
